import { Reveal } from "./motion";

const chapters = [
  { n: "01", title: "Child & Pet Safe", body: "Tightly-spaced high-tension cables (under 3 inches apart) make it impossible for children or pets to slip through — protection that never sleeps." },
  { n: "02", title: "The View Stays", body: "Thin, transparent steel lines all but vanish against the sky. You keep every bit of your skyline, sunlight and breeze." },
  { n: "03", title: "Weatherproof Steel", body: "Marine-grade stainless steel resists rust through Hyderabad monsoons and summers. No repainting, no corrosion, no compromise." },
  { n: "04", title: "10-Year Warranty", body: "Every installation is backed by a written warranty and free tension check-ups. Craftsmanship you can hold us to." },
];

const WHY_IMG = "https://images.pexels.com/photos/35729903/pexels-photo-35729903.jpeg?auto=compress&cs=tinysrgb&fm=webp&w=800";

export default function WhyChooseUs() {
  return (
    <section id="why" className="py-24 md:py-36 bg-steel-50">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal className="mb-16 max-w-2xl">
          <p className="font-label text-xs tracking-[0.3em] uppercase text-steel-500 mb-4">The manifesto</p>
          <h2 className="font-display font-black tracking-tighter text-steel-900 text-4xl md:text-6xl leading-none">
            Four reasons families across Hyderabad choose us.
          </h2>
        </Reveal>

        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            {chapters.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.06}>
                <div data-testid={`why-${c.n}`} className="grid grid-cols-12 gap-4 py-8 border-t border-steel-300 group">
                  <div className="col-span-3 md:col-span-2 font-display font-black text-4xl md:text-5xl text-steel-300 group-hover:text-steel-800 transition-colors">{c.n}</div>
                  <div className="col-span-9 md:col-span-10">
                    <h3 className="font-display font-bold text-2xl text-steel-900 mb-2">{c.title}</h3>
                    <p className="text-steel-600 leading-relaxed max-w-lg">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.1} className="h-full">
              <div className="relative h-[300px] lg:h-full min-h-[420px] overflow-hidden border border-steel-200">
                <img src={WHY_IMG} alt="Child safe balcony with invisible grills" loading="lazy" decoding="async" width={800} height={620} className="w-full h-full object-cover" />
                <div className="absolute inset-0 grill-lines" />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-steel-900/80 to-transparent p-6">
                  <p className="text-white font-display font-bold text-xl leading-tight">Peace of mind,<br />floor after floor.</p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
